import React from 'react'
import { RankingStm, RankingStmProps } from './rankingStm'
import type { ItemPayload } from './Dnd/type'
import { Draggable } from './Dnd/Draggable'

export type DraggableRankingStmProps = RankingStmProps & ItemPayload

export const DraggableRankingStm = (p: DraggableRankingStmProps) => {
    const { stm, sourceContainerId } = p
    return (
        <Draggable
            as={RankingStm}
            id={String(stm.valueKey)}
            data={{ sourceContainerId }}
            {...p}
        />
    )
}
